import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "antd";
import FilterContainer from "../containers/FilterContainer";
import DimensionFilterContainer from "../containers/DimensionFilterContainer";

class Z3 extends Component {
	constructor(props) {
		super(props);
	}

	renderFilter(filter, nbElts, kpi) {
		return (
			<Col
				span={Math.min(4, Math.floor(24 / nbElts))}
				style={{ ...styles.filtersContainer }}
			>
				<FilterContainer filter={filter} kpi={kpi}/>
			</Col>
		);
	}

	renderFilters() {
		let { filters, dimension, hideDimensionFilter,kpi } = this.props;
		const elts = [];
		let nbElts = filters.length + 1 || 1;

		//add dimension filter
		if (dimension && dimension.id !== "globale") {
			nbElts++;
			elts.push(this.renderFilter(dimension, nbElts, kpi));
		}

		filters.map(filter => {
			if (
				filter &&
				typeof filter === "object" &&
				(!dimension || filter.id !== dimension.id)
			) {
				if (!filter.hasOwnProperty("display") || filter.display(kpi))
				elts.push(this.renderFilter(filter, nbElts, kpi));
			}
		});

		if (!hideDimensionFilter) {
			elts.unshift(
				<Col
					span={Math.min(4, Math.floor(24 / nbElts))}
					style={{ ...styles.filtersContainer }}
				>
					<DimensionFilterContainer />
				</Col>
			);
		}
		return elts;
	}

	render() {
		return (
			<Row style={{ ...styles.contentFilters }}>{this.renderFilters()}</Row>
		);
	}
}

Z3.propTypes = {
	filters: PropTypes.array.isRequired,
	dimension: PropTypes.object,
};

const styles = {
	debug: {
		border: "1px solid green",
	},
	contentFilters: {
		paddingTop: 5,
		paddingBottom: 5,
	},
	item: {
		fontWeight:"bold",
		marginTop: 15,
		marginBottom: 5,
	},
	filtersContainer: {
		//paddingLeft: 5,
		paddingRight: 5,
		marginBottom: 5,
		minWidth: 150,
	},
};

export default Z3;



// WEBPACK FOOTER //
// src/modules/stats/components/Z3.js